import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoDeleteEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoDeleteEventVO.validationSchema()
  );

  constructor(readonly value: RoomBrandLogoDeleteEvent) {
    JsonSchemaValidator.assert(RoomBrandLogoDeleteEventVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandLogoDeleteEvent {
  roomId: RoomId;
}
